import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Organization } from '../../types';
import { useNotification } from '../../context/NotificationContext';
import { organizationService } from '../../services';
interface QSConfigCardProps {
  organization: Organization;
  onUpdate: (updatedOrg: Organization) => void;
}

const QSConfigCard: React.FC<QSConfigCardProps> = ({
  organization,
  onUpdate,
}) => {
  const { showNotification } = useNotification();
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);

  // Verwende die Organization-Prop direkt als State-Quelle
  const qsEnabled = organization.qs_enabled || false;
  
  const handleToggleChange = async (checked: boolean) => {
    if (saving) return; // Verhindere mehrfache Klicks während des Speicherns
    
    setSaving(true);
    
    try {
      
      const response = await organizationService.updateOrganization(organization._id, {
        qs_enabled: checked
      });
      
      
      // Nur qs_enabled aktualisieren, ohne Nutzer-Daten zu überschreiben
      onUpdate({
        ...organization,
        qs_enabled: checked
      });
      showNotification(
        checked 
          ? t('admin:qsConfig.enabledFor', { name: organization.name })
          : t('admin:qsConfig.disabledFor', { name: organization.name }),
        'success'
      );
    } catch (error) {
      console.error('Error updating QS configuration:', error);
      showNotification(
        t('admin:qsConfig.saveError'),
        'error'
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card sx={{ 
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        borderRadius: '8px',
        border:  '1px solid rgb(0 0 0 / 0.05)',
        minHeight: '150px',
      bgcolor: 'background.paper' 
    }}>
      <CardContent sx={{ p: 3 }}>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={qsEnabled}
                onChange={(e) => handleToggleChange(e.target.checked)}
                disabled={saving}
                color="default"
                sx={{
                  '&.Mui-checked': {
                    color: '#000000',
                  },
                }}
              />
            }
            label={
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {t('admin:qsConfig.qsEnabled', { 
                    status: qsEnabled 
                      ? t('admin:qsConfig.enabled')
                      : t('admin:qsConfig.disabled')
                  })}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280' }}>
                  {qsEnabled 
                    ? t('admin:qsConfig.enabledDescription')
                    : t('admin:qsConfig.disabledDescription')
                  }
                </Typography>
              </Box>
            }
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default QSConfigCard;